import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=752a8832&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"
import style0 from "./Badge.vue?vue&type=style&index=0&id=752a8832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a8832",
  null
  
)

export default component.exports